import { useContext } from 'react';
import { assertNonNull } from '../queues/utils/assert-non-null';
import { UnitEmergencyContext } from './unit-emergency-provider';

export function useUnitEmergency() {
    const unitEmergencyInfo = useContext(UnitEmergencyContext);
    assertNonNull(unitEmergencyInfo, 'Unexpectedly did not find Unit Emergency information.');

    return unitEmergencyInfo;
}
